import { inject, Injectable, Injector } from '@angular/core';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
    providedIn: 'root'
})
export class NotificationModalService {
    private readonly injector = inject(Injector);

    add(title: string, message: string): void {
        const modalService = this.injector.get(NzModalService);
        const modalOptions: ModalOptions = {
            nzTitle: title,
            nzContent: message,
            nzCentered: true
        };

        modalOptions.nzTitle = title;

        modalService.warning(modalOptions);
    }
}

